import { useWatch } from 'react-hook-form';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { notificationService } from '../../../../services/notificationService';
import { EpStepContent, EpStepSelect } from '../../components';

export default function NotificationIncidentInput({
  translations,
}: {
  translations: unknown;
}) {
  const [NotificationCategory, NotificationType] = useWatch({
    name: [
      'notificationCategoryId.inputValue',
      'notificationTypeId.inputValue',
    ],
  });
  const { getNotificationIncidentsTypes } = notificationService;
  const { data: IncidentOptions, isFetching } = getNotificationIncidentsTypes(
    NotificationType,
    NotificationCategory,
  );

  if (isFetching) return null;

  if (IncidentOptions?.itens && IncidentOptions?.itens.length > 0) {
    return (
      <EpStepContent.Label label={t(translations, 'Incident') + ' *'}>
        <EpStepSelect
          data={IncidentOptions?.itens}
          errorMessage={t(translations, '* Required Fied')}
          registerId={'notificationIncidentId'}
        />
      </EpStepContent.Label>
    );
  }

  return null;
}
